import React, { useState } from "react";
import { AiFillFileAdd } from "react-icons/ai";
import { Link } from "react-router-dom";
import { RoutePath } from "../../../utility/Constant";
import { FaRegEdit } from "react-icons/fa";
import { MdDeleteForever } from "react-icons/md";

function JobsCard({ project, user, handleSingleDelete }) {
  const { jobsContent, jobsContentAdd } = RoutePath;
  const [showMore, setShowMore] = useState(false);
  const [visibility, setVisibility] = useState(true);

  const handleDelete = async () => {
    const res = await handleSingleDelete(project._id);
    if (typeof res === "boolean" && res === true) {
      setVisibility(false);
    }
  };

  return (
    <>
      {visibility && (
        <div className="group relative border flex flex-col overflow-hidden shadow-lg rounded-lg h-full bg-white">
          {project ? (
            <div className="p-4 flex flex-col justify-between h-full gap-3">
              {/* Date and Country */}
              <div className="flex flex-col md:flex-row justify-between items-start md:items-center border-b pb-2 text-sm text-gray-700 gap-2">
                <span className="flex items-center gap-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5 text-gray-500"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5"
                    />
                  </svg>
                  {project.date}
                </span>
                <span className="flex items-center gap-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5 text-gray-500"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M12.75 3.03v.568c0 .334.148.65.405.864l1.068.89c.442.369.535 1.01.216 1.49l-.51.766a2.25 2.25 0 01-1.161.886l-.143.048a1.107 1.107 0 00-.57 1.664c.369.555.169 1.307-.427 1.605L9 13.125l.423 1.059a.956.956 0 01-1.652.928l-.679-.906a1.125 1.125 0 00-1.906.172L4.5 15.75l-.612.153M12.75 3.031a9 9 0 00-8.862 12.872M12.75 3.031a9 9 0 016.69 14.036m0 0l-.177-.529A2.25 2.25 0 0017.128 15H16.5l-.324-.324a1.453 1.453 0 00-2.328.377l-.036.073a1.586 1.586 0 01-.982.816l-.99.282c-.55.157-.894.702-.8 1.267l.073.438c.08.474.49.821.97.821.846 0 1.598.542 1.865 1.345l.215.643m5.276-3.67a9.012 9.012 0 01-5.276 3.67m0 0a9 9 0 01-10.275-4.835"
                    />
                  </svg>
                  {project.country_name}
                </span>
              </div>

              {/* Title */}
              <h2 className="text-lg font-semibold break-words mt-2">
                {project.title}
              </h2>

              {/* Description */}
              <div className="text-gray-600">
                <p className="hidden md:block">

                  {project.subtitle}
                </p>
              </div>

              {/* Action Buttons */}
              <div className="flex items-center justify-between mt-4 border-t pt-3">
                <button
                  onClick={() => setShowMore((prev) => !prev)}
                  className="text-sm text-red-500 hover:text-[#DB0029] hidden md:block"
                >
                  {project?.description?.length > 99 &&
                    (showMore ? "Show less" : "Show more")}
                </button>

                <div className="flex gap-2 text-xs md:text-base">
                  <Link
                    to={`/${jobsContent}/${project._id}`}
                    className="btn btn-outline btn-xs text-blue-500 hover:text-blue-700 transition duration-150 rounded-lg"
                  >
                    <FaRegEdit size={20} />
                  </Link>
                  {user === "admin" && (
                    <button
                      id={project._id}
                      onClick={handleDelete}
                      className="btn btn-outline btn-xs text-red-500 px-3 hover:text-red-700 transition duration-150 rounded-lg"
                    >
                      <MdDeleteForever size={23} />
                    </button>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <Link
              to={`/${jobsContentAdd}`}
              className="flex justify-center items-center rounded-xl bg-gray-50 shadow-xl h-full"
            >
              <p className="text-8xl group-hover:text-[#DB0029]">
                <AiFillFileAdd />
              </p>
            </Link>
          )}
        </div>
      )}
    </>
  );
}

export default JobsCard;
